document.addEventListener('DOMContentLoaded', function (event) {
  init();
  removeArrows();
  removeBullets();
});

function init() {
  let slider = new Swiper('.Slider .swiper-container', {
    loop: true,
    slidesPerView: 1,

    navigation: {
      prevEl: '.swiper-btn-prev',
      nextEl: '.swiper-btn-next',
    },

    threshold: 30,

    pagination: {
      clickable: true,
      el: '.swiper-pagination',
      type: 'bullets',
    },

    on: {
      init: function () {
        let slidesCount = this.slides.length - 2;
        if (slidesCount <= 1) {
          this.el.querySelector('.swiper-btn-prev').classList.add('hide');
          this.el.querySelector('.swiper-btn-next').classList.add('hide');
          this.el.querySelector('.swiper-pagination').classList.add('hide');
        }
      },
    },
  });
}

function removeArrows() {
  let sliders = document.querySelectorAll('.Slider');
  if (sliders) {
    sliders.forEach(function (slider) {
      console.log(slider);
    });
  }
}

function removeBullets() {}
